import React, { useEffect, useRef } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import TimeRegistrationApp from './components/TimeRegistrationApp';
import './App.css';

const getDateString = () => new Date().toISOString().split('T')[0];

function App() {
  const lastActiveDateRef = useRef<string>(getDateString());

  // Auto-refresh when the browser tab becomes visible on a new day
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const today = getDateString();
        if (today !== lastActiveDateRef.current) {
          lastActiveDateRef.current = today;
          window.location.reload();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return (
    <AuthProvider>
      <div className="App">
        <TimeRegistrationApp />
      </div>
    </AuthProvider>
  );
}

export default App;
